import React from "react";

import { useHistory } from "react-router-dom";

// Scss imports
import css from "./TableComponent.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import { getCertainPaper } from "../../../redux/actions/papersActions";
import { getCertainArchive } from "../../../redux/actions/archiveActions";

interface TableComponentProps {
  data: any;
  tableType?: string;
}

const TableComponent: React.FC<TableComponentProps> = ({ data, tableType }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  // Data
  var dataColumns = data.columns;
  var dataRows = data.rows;

  var tableHeaders = (
    <thead>
      <tr>
        {dataColumns.map(function (column) {
          return <th>{column}</th>;
        })}
      </tr>
    </thead>
  );

  var tableBody =
    dataRows &&
    dataRows.map(function (row) {
      return (
        <tr>
          {dataColumns.map(function (column) {
            return (
              <td
                className={column === "Ажурирање" ? css.purpleCell : ""}
                onClick={(e: any) => {
                  if (column === "Ажурирање") {
                    tableType === "paper"
                      ? dispatch(getCertainPaper(row[column], history))
                      : dispatch(getCertainArchive(row[column], history));
                  }
                }}
              >
                {column === "Ажурирање" ? "Ажурирај" : row[column]}
              </td>
            );
          })}
        </tr>
      );
    });

  // Decorate with Bootstrap CSS
  return (
    <table className={`${css.table}`}>
      {tableHeaders}
      {tableBody}
    </table>
  );
};

export default TableComponent;
